import {
  InputTypes,
  JobTypesAnswer,
  JobTypesOptions,
  JobTypesWithRequirements,
} from "./interfaces";

// TODO: After successful testing, replace this with new version of requiredOptions from ./index.new.ts

// Hope you are well, after having a little play around on the training system, can we add the following please 😊

// Is it vented or unvented needs to be across all cylinder job types

type baseFieldProps = {
  answers: JobTypesAnswer[] | undefined;
  type: InputTypes;
  depends: number | null;
};

const answerYesNo = [
  { value: "yes", text: "Yes" },
  { value: "no", text: "No" },
];

const answerYesNoBoolean = [
  { value: "true", text: "Yes" },
  { value: "false", text: "No" },
];

const answerAge = [
  { value: "1", text: "1 year" },
  { value: "2", text: "2 years" },
  { value: "3", text: "3 years" },
  { value: "4", text: "4 years" },
  { value: "5", text: "5 years" },
  { value: "6", text: "6 years" },
  { value: "7", text: "7 years" },
  { value: "8", text: "8 years" },
  { value: "9", text: "9 years" },
  { value: "10", text: "10 years or more" },
];

const textQuestionProps: baseFieldProps = {
  answers: [],
  type: "text",
  depends: null,
};

const messageQuestionProps: baseFieldProps = {
  answers: [],
  type: "message",
  depends: null,
};

const radioQuestionProps: baseFieldProps = {
  answers: [],
  type: "radio",
  depends: null,
};

const radioYesNoProps: baseFieldProps = {
  ...radioQuestionProps,
  answers: answerYesNo,
};

const radioYesNoBooleanProps: baseFieldProps = {
  ...radioQuestionProps,
  answers: answerYesNoBoolean,
};

const radioAgeProps: baseFieldProps = {
  ...radioQuestionProps,
  answers: answerAge,
};

export const requiredOptions: JobTypesOptions = {
  [JobTypesWithRequirements[JobTypesWithRequirements.DREXT]]: [
    {
      name: "TypeOfBlockedDrain",
      question: "Type of blocked drain",
      answers: [
        { value: "SmallGratedGully", text: "Small grated gully" },
        { value: "Manhole", text: "Manhole" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoBooleanProps,
      name: "LocateDrain",
      question: "Can you locate the drain?",
    },
    {
      ...textQuestionProps,
      name: "DrainLocation",
      question: "Where is the drain?",
      depends: 1,
    },
    {
      ...radioYesNoProps,
      name: "Overflowing",
      question: "Is it overflowing?",
    },
    {
      name: "SharedDrainage",
      question: "Do you know if it is shared drainage? (3 properties or more)",
      answers: [
        { value: "yes", text: "Yes" },
        { value: "no", text: "No" },
        { value: "dontknow", text: "Don't know" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...messageQuestionProps,
      name: "AdviseCustomer",
      question:
        "If drainage is shared by 3 or more properties, please advise customer that the water board is required and log call as TRADE NOT COVERED",
      depends: 3,
      trigger: "Yes",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.DRINT]]: [
    {
      name: "BlockedItem",
      question: "What is blocked?",
      answers: [
        { value: "Toilet", text: "Toilet" },
        { value: "KitchenSink", text: "Kitchen sink" },
        { value: "BathroomBasin", text: "Bathroom basin" },
        { value: "ShowerTray", text: "Shower tray" },
        { value: "Other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "OnlyToilet",
      question:
        "If blockage is a toilet, is this the only toilet in the property?",
      answers: [
        { value: "yes", text: "Yes" },
        { value: "no", text: "No" },
        { value: "Na", text: "Not applicable" },
      ],
      type: "radio",
      depends: 0,
      trigger: "Toilet",
    },
    {
      name: "OtherBlockages",
      question:
        "Is there anything else in the property blocked or slow draining?",
      answers: [
        { value: "true", text: "Yes - add in additional notes below" },
        { value: "false", text: "No" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...textQuestionProps,
      name: "Duration",
      question: "How long has it been blocked/slow draining?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.SDSTV]]: [
    {
      name: "CctvReason",
      question: "Why is a CCTV survey required?",
      answers: [
        { value: "insurance", text: "Insurance" },
        { value: "reoccuring", text: "Reoccuring blockages" },
        { value: "recommendation", text: "Recommendation" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...textQuestionProps,
      name: "ManholeLocation",
      question: "Where is the manhole?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EEALI]]: [
    {
      name: "ApplianceType",
      question: "What needs to be installed?",
      answers: [
        { value: "cooker", text: "Cooker" },
        { value: "hob", text: "Hob" },
        { value: "fridge-freezer", text: "Fridge/Freezer" },
        { value: "washing-machine", text: "Washing Machine" },
        { value: "tumble-dryer", text: "Tumble Dryer" },
        { value: "dishwasher", text: "Dishwasher" },
        { value: "cooker-hood", text: "Cooker Hood" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "HadBefore",
      question: "Have you had one there before?",
      answers: [
        {
          text: "Yes",
          value: "true",
        },
        {
          text: "No",
          value: "false",
        },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EECLW]]: [
    {
      name: "Location",
      question: "Where is the light located?",
      answers: [
        { value: "Bathroom", text: "Bathroom" },
        { value: "Lounge", text: "Lounge" },
        { value: "Bedroom", text: "Bedroom" },
        { value: "Outside", text: "Outside" },
        { value: "Kitchen", text: "Kitchen" },
        { value: "UtilityRoom", text: "Utility room" },
        { value: "Conservatory", text: "Conservatory" },
        { value: "MultipleRooms", text: "Multiple rooms" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "LightType",
      question: "What type of lights?",
      answers: [
        { value: "Pendant", text: "Pendant" },
        { value: "SpotLight", text: "Spot light" },
        { value: "Led", text: "LED" },
        { value: "FluorescentTubing", text: "Fluorescent tubing" },
        { value: "Security", text: "Security" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "RepairOrReplace",
      question: "Is this job repair or replace?",
      answers: [
        { value: "Repair", text: "Repair" },
        { value: "Replace", text: "Replace" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "NumLights",
      ...textQuestionProps,
      question:
        "How many lights need changing? (3 or more please change job type to 'Repair Or Replace A Light 3 Or More [EECLR]')",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EEFBW]]: [
    {
      ...radioYesNoProps,
      name: "KnowFuseboxLocation",
      question: "Do you know where your fusebox is?",
    },
    {
      name: "RcdSwitches",
      question: "Are the RCD's (trip switches) up or down?",
      answers: [
        { value: "Up", text: "Up" },
        { value: "Down", text: "Down" },
        { value: "Unsure", text: "Unsure" },
      ],
      type: "radio",
      depends: 0,
      trigger: "Yes",
    },
  ],

  [JobTypesWithRequirements[JobTypesWithRequirements.EELSW]]: [
    {
      name: "Location",
      question: "Where in the property is it?",
      answers: [
        { value: "Bathroom", text: "Bathroom" },
        { value: "Lounge", text: "Lounge" },
        { value: "Bedroom", text: "Bedroom" },
        { value: "Outside", text: "Outside" },
        { value: "Kitchen", text: "Kitchen" },
        { value: "UtilityRoom", text: "Utility room" },
        { value: "Conservatory", text: "Conservatory" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "SwitchType",
      question: "What type of switch?",
      answers: [
        { value: "SingleSocket", text: "Single socket" },
        { value: "DoubleSocket", text: "Double socket" },
        { value: "IsolationSwitch", text: "Isolation switch" },
        { value: "PullCordSwitch", text: "Pull cord switch" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "RepairOrReplace",
      question: "Is this job repair or replace?",
      answers: [
        { value: "Repair", text: "Repair" },
        { value: "Replace", text: "Replace" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EESHR]]: [
    {
      name: "ApplianceType",
      question: "What appliance is it?",
      answers: [
        { value: "WashingMachine", text: "Washing machine" },
        { value: "Dishwasher", text: "Dishwasher" },
        { value: "AmericanFridge", text: "American fridge" },
        {
          value: "IntegratedWashingMachine",
          text: "Integrated washing machine",
        },
        { value: "IntegratedDishwasher", text: "Integrated dishwasher" },
        { value: "Other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "PluggedIntoAnotherSocket",
      question: "Have you plugged it into another socket?",
    },
    {
      ...radioYesNoProps,
      name: "CanPlugAnotherAppliance",
      question: "Can you plug another appliance into that socket?",
    },
    {
      ...messageQuestionProps,
      name: "RepairOrReplace",
      question:
        "If other appliance does not work this job should be repair or replace socket--If  other appliance works then this is an appliance problem not covered",
      depends: 2,
      trigger: "Yes",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EESHW]]: [
    {
      name: "RepairOrReplace",
      question: "Is this repair or replace?",
      answers: [
        { value: "Repaired", text: "Repair" },
        { value: "Replaced", text: "Replace" },
        { value: "Unsure", text: "Unsure" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "FanLocation",
      question: "Where is the extractor fan located?",
      answers: [
        { value: "Kitchen", text: "Kitchen" },
        { value: "Bathroom", text: "Bathroom" },
        { value: "Other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "PowerToSwitch",
      question: "Is there power going to the isolation/pull cord switch?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EESKW]]: [
    {
      name: "RepairOrReplace",
      question: "Is this repair or replace?",
      answers: [
        { value: "Repaired", text: "Repair" },
        { value: "Replaced", text: "Replace" },
        { value: "Unsure", text: "Unsure" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "SocketLocation",
      question: "Where is the socket located?",
      answers: [
        { value: "Lounge", text: "Lounge" },
        { value: "Bedroom", text: "Bedroom" },
        { value: "Outside", text: "Outside" },
        { value: "Kitchen", text: "Kitchen" },
        { value: "UtilityRoom", text: "Utility room" },
        { value: "Conservatory", text: "Conservatory" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "SocketType",
      question: "What type of socket?",
      answers: [
        { value: "SingleSocket", text: "Single socket" },
        { value: "DoubleSocket", text: "Double socket" },
        { value: "IsolationSwitch", text: "Isolation switch" },
        { value: "PullCordSwitch", text: "Pull cord switch" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EEXXX]]: [
    {
      ...radioYesNoBooleanProps,
      name: "KnowFuseboxLocation",
      question: "Do you know where your fusebox is?",
    },
    {
      name: "RCDSwitches",
      question: "Are the RCD's (trip switches) up or down?",
      answers: [
        { value: "up", text: "Up" },
        { value: "down", text: "Down" },
        { value: "unsure", text: "Unsure" },
      ],
      type: "radio",
      depends: 0,
      trigger: "Yes",
    },
    {
      name: "OnlyPropertyAffected",
      question: "Is it only your property affected?",
      answers: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
        { value: "unsure", text: "Unsure" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "WholeOrPartial",
      question: "Is it the whole property or just partial?",
      answers: [
        { value: "whole", text: "Whole" },
        { value: "partial", text: "Partial" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...textQuestionProps,
      name: "PartialLocation",
      question: "If partial, where?",
      depends: 3,
      trigger: "Partial",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.ELSRP]]: [
    {
      name: "PropertyType",
      question: "What type of property?",
      answers: [
        { value: "house", text: "House" },
        { value: "bungalow", text: "Bungalow" },
        { value: "flat", text: "Property" },
        { value: "apartment", text: "Apartment" },
        { value: "business", text: "Business" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "BusinessRooms",
      question: "If property is a business, how many rooms?",
      answers: [
        { value: "notApplicable", text: "Not Applicable" },
        { value: "threePlus", text: "3+" },
        { value: "fivePlus", text: "5+" },
        { value: "eightPlus", text: "8+" },
        { value: "tenPlus", text: "10+" },
      ],
      type: "radio",
      depends: 0,
      trigger: "Business",
    },
    {
      ...messageQuestionProps,
      name: "BookAsQuote",
      question:
        "If business property is 10+ rooms, this should be booked as a quote (set as rewire)",
      depends: 1,
      trigger: "10+",
    },
    {
      name: "Bedrooms",
      question: "How many bedrooms in the property?",
      answers: [
        { value: "one", text: "One" },
        { value: "two", text: "Two" },
        { value: "three", text: "Three" },
        { value: "four", text: "Four" },
        { value: "fiveOrMore", text: "Five or more" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HIHOB]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it a mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question:
        "If appliance is not mains gas, this is electrics or TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoBooleanProps,
      name: "HaveCooker",
      question: "Do you have the cooker?",
    },
    {
      ...radioYesNoBooleanProps,
      name: "SecondHand",
      question: "Is the cooker second hand?",
    },
    {
      name: "CookerChainAndHose",
      question: "Do you have cooker chain and hose?",
      answers: [
        { value: "chain", text: "Chain" },
        { value: "hose", text: "Hose" },
        { value: "both", text: "Both" },
        { value: "none", text: "None" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "SamePlace",
      question: "Is there existing gas pipe work where you want the cooker?",
    },
    {
      ...messageQuestionProps,
      name: "GasRun",
      question: "Please change job type to 'Install new gas run' - HIHOR",
      depends: 5,
      trigger: "No",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HISMT]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it a mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question: "If boiler is not mains gas, this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      name: "ThermostatLocation",
      question: "Is the thermostat on the boiler or away from the boiler?",
      answers: [
        { value: "on_boiler", text: "On boiler" },
        { value: "off_boiler", text: "Off boiler" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HRLEK]]: [
    {
      ...radioYesNoBooleanProps,
      name: "CADENT",
      question: "Was gas capped off by CADENT?",
    },
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question:
        "If this is not mains gas, but LPG switch to correct job type, otherwise this is TRADE NOT COVERED",
      depends: 1,
      trigger: "No",
    },
    {
      ...radioYesNoBooleanProps,
      name: "LeakLocation",
      question: "Do you know where the leak is?",
    },
    {
      name: "LeakExposedOrHidden",
      question: "Is the leak exposed or hidden?",
      answers: [
        { value: "exposed", text: "Exposed" },
        { value: "hidden", text: "Hidden" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HSFIR]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question:
        "If this is not mains gas, but LPG switch to correct job type, otherwise this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoBooleanProps,
      name: "FireWorking",
      question: "Is the fire working?",
    },
    {
      ...radioAgeProps,
      name: "FireAge",
      question: "How old is the Fire?",
    },
    {
      ...radioYesNoBooleanProps,
      name: "Manual",
      question: "Do you have a manual?",
    },
    {
      ...textQuestionProps,
      name: "MakeModel",
      question: "Make and Model",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HSGAS]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question:
        "If this is not mains gas, but LPG switch to correct job type, otherwise this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    // boiler breakdown job type selected - required options add questions - is it LPG boiler?
    // TODO: add this question to the boiler breakdown job type as required per ticket #14242
    // {
    //   name: "IsLPGBoiler",
    // }
    {
      ...radioYesNoProps,
      name: "BoilerWorking",
      question: "Is the boiler working?",
    },
    {
      ...messageQuestionProps,
      name: "BookGasBoilerBreakdown",
      question:
        "If boiler is not working, this must be booked as a gas boiler breakdown and inform the customer it must be repaired before servicing",
      depends: 2,
      trigger: "No",
    },
    {
      ...radioAgeProps,
      name: "BoilerAge",
      question: "How old is the Boiler?",
    },
    {
      ...textQuestionProps,
      name: "MakeModel",
      question: "Make and Model",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HBSSP]]: [
    {
      name: "FuelType",
      question: "What do the boiler run on?",
      answers: [
        { value: "natural-gas", text: "Natural Gas" },
        { value: "bottled-gas", text: "Bottled Gas" },
        { value: "oil", text: "Oil" },
        { value: "lpg", text: "LPG" },
        { value: "solid-fuel", text: "Solid Fuel" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "Working",
      question: "Is the boiler working?",
      answers: [
        {
          text: "Yes",
          value: "true",
        },
        {
          text: "No",
          value: "false",
        },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "BoilerAge",
      question: "How old is the Boiler?",
      answers: [
        { value: "1", text: "1 Year" },
        { value: "2", text: "2 Years" },
        { value: "3", text: "3 Years" },
        { value: "4", text: "4 Years" },
        { value: "5", text: "5 Years" },
        { value: "6", text: "6 Years" },
        { value: "7", text: "7 Years" },
        { value: "8", text: "8 Years" },
        { value: "9", text: "9 Years" },
        { value: "10+", text: "10 Years Or More" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "MakeModel",
      question: "Make and Model",
      type: "text",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HBSEP]]: [
    {
      name: "FuelType",
      question: "What do the boiler run on?",
      answers: [
        { value: "natural-gas", text: "Natural Gas" },
        { value: "bottled-gas", text: "Bottled Gas" },
        { value: "oil", text: "Oil" },
        { value: "lpg", text: "LPG" },
        { value: "solid-fuel", text: "Solid Fuel" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "Working",
      question: "Is the boiler working?",
      answers: [
        {
          text: "Yes",
          value: "true",
        },
        {
          text: "No",
          value: "false",
        },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "BoilerAge",
      question: "How old is the Boiler?",
      answers: [
        { value: "1", text: "1 Year" },
        { value: "2", text: "2 Years" },
        { value: "3", text: "3 Years" },
        { value: "4", text: "4 Years" },
        { value: "5", text: "5 Years" },
        { value: "6", text: "6 Years" },
        { value: "7", text: "7 Years" },
        { value: "8", text: "8 Years" },
        { value: "9", text: "9 Years" },
        { value: "10+", text: "10 Years Or More" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "MakeModel",
      question: "Make and Model",
      type: "text",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HSTAT]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question:
        "If this is not mains gas, but LPG switch to correct job type, otherwise this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "FireIssue",
      question: "What is wrong with the fire?",
    },
    {
      ...radioAgeProps,
      name: "FireAge",
      question: "How old is the Fire?",
    },
    {
      ...radioYesNoBooleanProps,
      name: "Manual",
      question: "Do you have a manual?",
    },
    {
      ...textQuestionProps,
      name: "MakeModel",
      question: "Make and Model",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.LRPCL]]: [
    {
      ...radioYesNoBooleanProps,
      name: "LockOpen",
      question: "Is the lock open?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.LRPGD]]: [
    {
      ...radioYesNoBooleanProps,
      name: "LockOpen",
      question: "Is the lock open?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.LRPML]]: [
    {
      ...radioYesNoBooleanProps,
      name: "LockOpen",
      question: "Is the lock open?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.LRPMD]]: [
    {
      ...radioYesNoBooleanProps,
      name: "LockOpen",
      question: "Is the lock open?",
    },
    {
      name: "WhatIsLocked",
      question: "What is locked?",
      answers: [
        { value: "postbox", text: "Postbox" },
        { value: "small-key-safe", text: "Small Key Safe" },
        { value: "large-metal-safe", text: "Large Metal Safe" },
        { value: "office-cabinet", text: "Office Cabinet" },
        { value: "furniture", text: "Furniture" },
        { value: "suitcase", text: "Suitcase" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PDCDW]]: [
    {
      name: "ApplianceType",
      question: "What appliance needs to be disconnected?",
      answers: [
        { value: "WashingMachine", text: "Washing machine" },
        { value: "Dishwasher", text: "Dishwasher" },
        { value: "AmericanFridge", text: "American fridge" },
        {
          value: "IntegratedWashingMachine",
          text: "Integrated washing machine",
        },
        { value: "IntegratedDishwasher", text: "Integrated dishwasher" },
        { value: "Other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...textQuestionProps,
      name: "InstallNewAppliance",
      question: "Does the customer want us to install a new appliance?",
    },
    {
      ...textQuestionProps,
      name: "Attachments",
      question: "If yes, does the customer have all attachments?",
    },
    {
      ...textQuestionProps,
      name: "FreeText",
      question: "Free Text Or Message",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PIBSN]]: [
    {
      name: "InstallationType",
      question: "What needs to be installed?",
      answers: [
        { value: "Basin", text: "Basin" },
        { value: "Bath", text: "Bath" },
        { value: "Sink", text: "Sink" },
        { value: "Toilet", text: "Toilet" },
        { value: "Bidet", text: "Bidet" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "HadOneBefore",
      question: "Have you had one there before?",
    },
    {
      ...radioYesNoProps,
      name: "MaterialsReady",
      question: "Do you have materials ready to be installed?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PIPMP]]: [
    {
      name: "RepairOrReplacement",
      question: "Is this repair or replacement?",
      answers: [
        { value: "Repaired", text: "Repaired" },
        { value: "Replaced", text: "Replaced" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "PumpFeed",
      question: "What does the pump feed?",
      answers: [
        { value: "Shower", text: "Shower" },
        { value: "SaniFlow", text: "Sani flow" },
        { value: "CentralHeatingTank", text: "Central heating tank" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLBTH]]: [
    {
      ...radioYesNoProps,
      name: "HolesOrCracks",
      question: "Are there any holes or cracks in the bath?",
    },
    {
      ...messageQuestionProps,
      name: "NewBathRequired",
      question:
        "If yes, this customer must be advised that a new bath is required and the job type changed to 'Install Fresh Pipe Work [PLWKE]'",
      depends: 0,
      trigger: "Yes",
    },
    {
      ...radioYesNoBooleanProps,
      name: "BathPanelRemovable",
      question: "Can the bath panel be removed easily?",
    },
    {
      name: "LeakFrequency",
      question: "Does it leak all the time or when in use?",
      answers: [
        { value: "alltime", text: "Leak all the time" },
        { value: "inuse", text: "Leak in use" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...textQuestionProps,
      name: "LeakLocation",
      question: "Where can you see the visible sign of the leak?",
      depends: 1,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLCYL]]: [
    {
      name: "WhereLeaks",
      question: "Where is it leaking?",
      answers: [
        { value: "cylinder", text: "Cylinder" },
        { value: "pipework", text: "Pipework To Cylinder" },
        { value: "valve", text: "Valve On Cylinder" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoBooleanProps,
      name: "CylinderIsolationPossible",
      question: "Can the cylinder be isolated?",
    },
    {
      name: "VentedOrUnvented",
      question: "Is it vented or unvented?",
      answers: [
        { value: "Vented", text: "Vented" },
        { value: "Unvented", text: "Unvented" },
        { value: "DontKnow", text: "Don’t know" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLFRO]]: [
    {
      name: "PipeLocation",
      question: "Where is the pipe located?",
      answers: [
        { value: "Outdoor", text: "Outdoor" },
        { value: "Indoor", text: "Indoor" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "Leaking",
      question: "Is it leaking?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLOVF]]: [
    {
      name: "OverflowConnection",
      question: "What is the overflow pipe connected to?",
      answers: [
        { value: "ToiletCistern", text: "Toilet cistern" },
        { value: "WaterTank", text: "Water tank" },
        { value: "HeaderTank", text: "Header tank" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoBooleanProps,
      name: "TankAccess",
      question: "Is there access to the tank?",
    },
    {
      ...textQuestionProps,
      name: "LeakDuration",
      question: "How long has it been leaking?",
    },
    {
      name: "LeakSeverity",
      question: "How severe is the leak?",
      answers: [
        { value: "Drip", text: "Drip" },
        { value: "Trickle", text: "Trickle" },
        { value: "Heavy", text: "Heavy" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLPIP]]: [
    {
      name: "HotOrColdWater",
      question: "Is it a cold or hot water pipe?",
      answers: [
        { value: "cold", text: "Cold" },
        { value: "hot", text: "Hot" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "PipeMaterial",
      question: "What is the pipe made of?",
      answers: [
        { value: "copper", text: "Copper" },
        {
          value: "lead",
          text: "Lead (if lead pipe we can only replace not repair)",
        },
        { value: "plastic", text: "Plastic" },
        { value: "steel", text: "Steel" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "PipeLocation",
      question: "Where in the property is the pipe?",
      answers: [
        { value: "kitchen", text: "Kitchen" },
        { value: "bathroom", text: "Bathroom" },
        { value: "toilet", text: "Toilet" },
        { value: "utility", text: "Utility room" },
        { value: "various", text: "Various" },
        { value: "outside", text: "Outside" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "LeakSeverity",
      question: "How severe is the leak?",
      answers: [
        { value: "drip", text: "Drip" },
        { value: "trickle", text: "Trickle" },
        { value: "heavy", text: "Heavy" },
        { value: "burst", text: "Burst" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "SupplyIsolated",
      question: "If pipe is burst, can the supply be isolated?",
      depends: 3,
      trigger: "Burst",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLPIS]]: [
    {
      ...radioYesNoProps,
      name: "VisibleSignOfWater",
      question: "Is there a visible sign of water showing?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question: "If leak is not visible, this TRADE is not covered",
      depends: 0,
      trigger: "No",
    },
    {
      name: "WaterOrWaterStainLocation",
      question: "Where is the water or water stain?",
      answers: [
        { value: "wall", text: "Wall" },
        { value: "floor", text: "Floor" },
        { value: "ceiling", text: "Ceiling" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "BehindWhat",
      question: "What is it behind?",
      answers: [
        { value: "floorboards", text: "Floorboards" },
        { value: "tiles", text: "Tiles" },
        { value: "plasterboard", text: "Plasterboard" },
        { value: "concrete", text: "Concrete" },
        { value: "brickwork", text: "Brickwork" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...messageQuestionProps,
      name: "AccessToPipework",
      question:
        "Advisory - Access will need to be made to the pipework before we can attend.",
      depends: 3,
      trigger: "Concrete|Brickwork",
    },
    {
      ...radioYesNoProps,
      name: "Authorization",
      question:
        "Advisory - In some instances, access may have to be made to locate and repair the leak, in these instances my engineer will inform you of this first and will ask you to authorise them to make access to carry out the repair. They will only make access once you have authorised them to do so. Do you give your authorisation?",
    },
    {
      name: "LeakSeverity",
      question: "How severe is the leak?",
      answers: [
        { value: "drip", text: "Drip" },
        { value: "trickle", text: "Trickle" },
        { value: "heavy", text: "Heavy" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLRAD]]: [
    {
      name: "LeakingComponent",
      question: "What is leaking?",
      answers: [
        { value: "Radiator", text: "Radiator" },
        { value: "Valve", text: "Valve" },
        { value: "Pipework", text: "Pipework" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "HoleOrSplit",
      question: "Is there a hole or split in the radiator?",
    },
    {
      name: "Room",
      question: "Which room is the radiator in?",
      answers: [
        { value: "Kitchen", text: "Kitchen" },
        { value: "Bedroom", text: "Bedroom" },
        { value: "Bathroom", text: "Bathroom" },
        { value: "Toilet", text: "Toilet" },
        { value: "UtilityRoom", text: "Utility room" },
        { value: "Various", text: "Various" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "Severity",
      question: "How severe is the leak?",
      answers: [
        { value: "Drip", text: "Drip" },
        { value: "Trickle", text: "Trickle" },
        { value: "Heavy", text: "Heavy" },
        { value: "Burst", text: "Burst" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLSIC]]: [
    {
      ...radioQuestionProps,
      name: "ShowerRepairReplace",
      question: "Are you looking for a repair or replacement?",
      answers: [
        { value: "repair", text: "Repair" },
        { value: "replacement", text: "Replacement" },
      ],
    },
    {
      ...messageQuestionProps,
      name: "ShowerChangeToRepair",
      question:
        "If this is a repair, change job type to 'Repair of a Shower [PLSRP]'.",
      depends: 0,
      altJobTypes: [JobTypesWithRequirements[JobTypesWithRequirements.PLSRP]],
      trigger: "Repair",
    },
    {
      ...radioYesNoProps,
      name: "ShowerAlreadyPurchased",
      question: "Have you already purchased a replacement?",
    },
    {
      ...messageQuestionProps,
      name: "ShowerChangeToStandardReplacement",
      question:
        "If the customer isn't supplying the replacement shower, change job type to 'Replacement of a Shower - 8.5KW White [PLSRT]'.",
      depends: 2,
      altJobTypes: [JobTypesWithRequirements[JobTypesWithRequirements.PLSRT]],
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "ShowerMake",
      question: "Do you know the kw or the make and model of the shower?",
    },
    {
      ...radioQuestionProps,
      name: "ShowerAccessibility",
      question: "Is the shower accessible or concealed?",
      answers: [
        { value: "accessible", text: "Accessible" },
        { value: "concealed", text: "Concealed" },
      ],
    },
    {
      ...radioAgeProps,
      name: "ShowerAge",
      question: "Do you know the age of the shower?",
    },
    // {
    //   ...textQuestionProps,
    //   name: "ShowerPreference",
    //   question: "Do you have a preference for repair or replacement?",
    // },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLSLP]]: [
    {
      name: "ShowerType",
      question: "What type of shower is it?",
      answers: [
        { value: "mixer", text: "Mixer" },
        { value: "electric", text: "Electric" },
        { value: "power", text: "Power" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "ElectricPower",
      question:
        "If the shower is electric, is there power going to the isolation switch/pull cord?",
      answers: [
        { value: "yes", text: "Yes" },
        { value: "no", text: "No" },
        { value: "na", text: "Not applicable" },
      ],
      type: "radio",
      depends: 0,
      trigger: "Electric",
    },
    {
      ...messageQuestionProps,
      name: "ElectricNoPower",
      question:
        "Advisory - If there is no power going to the shower, this job will have to be changed to 'No Power To An Electrical Appliance [EESHR]",
      depends: 1,
      trigger: "No",
    },
    {
      name: "ShowerIssue",
      question: "What is the issue with the shower?",
      answers: [
        { value: "nowater", text: "No water" },
        { value: "leakingunit", text: "Leaking from unit" },
        { value: "leakinghose", text: "Leaking from hose" },
        { value: "notcomingon", text: "Not coming on" },
        { value: "lowpressure", text: "Low pressure" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...textQuestionProps,
      name: "NotWorkingDuration",
      question: "How long has it not been working?",
    },
    {
      name: "ShowerLocation",
      question: "Where is it located?",
      answers: [
        { value: "abovebath", text: "Above bath" },
        { value: "cubicle", text: "Cubicle" },
        { value: "wetroom", text: "Wet room" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLSNL]]: [
    {
      ...radioYesNoProps,
      name: "SinkCondition",
      question: "Are there any holes or cracks in the sink?",
    },
    {
      ...messageQuestionProps,
      name: "NewSinkRequired",
      question:
        "If there are any holes or cracks in the sink, the customer must be advised that a new sink is required. Do you want to change the job type to 'Install Bathroom Fixture (Bath/Toilet/Sink) [PIBSN]'?",
      depends: 0,
      trigger: "Yes",
    },
    {
      name: "SinkLocation",
      question: "Where is your leaking sink located?",
      answers: [
        { value: "kitchen", text: "Kitchen" },
        { value: "bathroom", text: "Bathroom" },
        { value: "toilet", text: "Toilet" },
        { value: "utilityroom", text: "Utility room" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "LeakFrequency",
      question: "Does your sink leak all of the time or only when in use?",
      answers: [
        { value: "allthetime", text: "Leak all the time" },
        { value: "inuse", text: "Leak in use" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "LeakTiming",
      question:
        "If it leaks when in use – is it immediate or after it has been filled?",
      answers: [
        { value: "immediate", text: "Immediate" },
        { value: "afterfilled", text: "After being filled" },
      ],
      type: "radio",
      depends: 3,
      trigger: "Leak in use",
    },
    {
      name: "LeakSeverity",
      question: "How severe is the leak?",
      answers: [
        { value: "drip", text: "Drip" },
        { value: "trickle", text: "Trickle" },
        { value: "heavy", text: "Heavy" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLSRP]]: [
    {
      ...radioQuestionProps,
      name: "ShowerRepairReplace",
      question: "Are you looking for a repair or replacement?",
      answers: [
        { value: "repair", text: "Repair" },
        { value: "replacement", text: "Replacement" },
      ],
    },
    {
      ...messageQuestionProps,
      name: "ShowerChangeToReplacement",
      question:
        "The customer has confirmed this is a replacement, not a repair. Check if the customer is supplying the replcament shower and change the job type to one of the below.",
      depends: 0,
      altJobTypes: [
        JobTypesWithRequirements[JobTypesWithRequirements.PLSIC],
        JobTypesWithRequirements[JobTypesWithRequirements.PLSRT],
      ],
      trigger: "Replacement",
    },
    {
      ...radioQuestionProps,
      name: "ShowerAccessibility",
      question: "Is the shower accessible or concealed?",
      answers: [
        { value: "accessible", text: "Accessible" },
        { value: "concealed", text: "Concealed" },
      ],
    },
    {
      ...textQuestionProps,
      name: "ShowerMake",
      question: "Do you know the kw or the make and model of the shower?",
    },
    {
      ...radioAgeProps,
      name: "ShowerAge",
      question: "Do you know the age of the shower?",
    },
    // {
    //   ...textQuestionProps,
    //   name: "ShowerPreference",
    //   question: "Do you have a preference for repair or replacement?",
    // },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLSRT]]: [
    {
      ...radioQuestionProps,
      name: "ShowerRepairReplace",
      question: "Are you looking for a repair or replacement?",
      answers: [
        { value: "repair", text: "Repair" },
        { value: "replacement", text: "Replacement" },
      ],
    },
    {
      ...messageQuestionProps,
      name: "ShowerChangeToRepair",
      question:
        "If this is a repair, change job type to 'Repair of a Shower [PLSRP]'.",
      depends: 0,
      altJobTypes: [JobTypesWithRequirements[JobTypesWithRequirements.PLSRP]],
      trigger: "Repair",
    },
    {
      ...radioYesNoProps,
      name: "ShowerAlreadyPurchased",
      question: "Have you already purchased a replacement?",
    },
    {
      ...messageQuestionProps,
      name: "ShowerChangeToCustomerReplacement",
      question:
        "If the customer is supplying the replacement shower, change job type to 'Installation of a customer-supplied shower [PLSIC]'.",
      depends: 2,
      altJobTypes: [JobTypesWithRequirements[JobTypesWithRequirements.PLSIC]],
      trigger: "Yes",
    },
    {
      ...radioQuestionProps,
      name: "ShowerAccessibility",
      question: "Is the shower accessible or concealed?",
      answers: [
        { value: "accessible", text: "Accessible" },
        { value: "concealed", text: "Concealed" },
      ],
    },
    {
      ...textQuestionProps,
      name: "ShowerMake",
      question: "Do you know the kw or the make and model of the shower?",
    },
    {
      ...radioAgeProps,
      name: "ShowerAge",
      question: "Do you know the age of the shower?",
    },
    // {
    //   ...textQuestionProps,
    //   name: "ShowerPreference",
    //   question: "Do you have a preference for repair or replacement?",
    // },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLSTK]]: [
    {
      name: "RepairOrReplacement",
      question: "Do you want repair or replacement?",
      answers: [
        {
          text: "Repaired",
          value: "repair",
        },
        {
          text: "Replaced",
          value: "replace",
        },
        {
          text: "Unsure",
          value: "unsure",
        },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoBooleanProps,
      name: "AccessToOutside",
      question: "Do you have access to the outside?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLTFF]]: [
    {
      name: "BlockedToilet",
      question: "Is the toilet blocked?",
      answers: [
        {
          value: "yes",
          text: "Yes (change job type to 'Blocked Drain - Internal [DRINT]')",
        },
        { value: "no", text: "No" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "ToiletFlushType",
      question: "What type of toilet flush have you got?",
      answers: [
        { value: "button", text: "Button" },
        { value: "handle", text: "Handle flush" },
        { value: "pullchain", text: "Pull chain" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "ConcealedCistern",
      question: "Is cistern a concealed cistern?",
    },
    {
      name: "ToiletLocation",
      question: "Where is the toilet located?",
      answers: [
        { value: "upstairs", text: "Upstairs" },
        { value: "downstairs", text: "Downstairs" },
        { value: "ensuite", text: "Ensuite" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "SingleToilet",
      question: "Is this the only toilet in the property?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLTFP]]: [
    {
      name: "ToiletType",
      question: "Toilet Type",
      answers: [
        { value: "button", text: "Button" },
        { value: "handle", text: "Handle flush" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoBooleanProps,
      name: "AccessToCistern",
      question: "Is there access to cistern?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLTLT]]: [
    {
      name: "LeakLocation",
      question: "Where is the toilet leaking from?",
      answers: [
        { value: "bowl", text: "Bowl" },
        { value: "cistern", text: "Cistern" },
        { value: "inlet", text: "Pipework inlet copper" },
        { value: "backbottom", text: "Bottom at the back" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "LeakTiming",
      question: "Does it leak all the time or when in use?",
      answers: [
        { value: "allthetime", text: "Leak all the time" },
        { value: "inuse", text: "Leak in use" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "ToiletDamage",
      question: "Is there a hole or crack in the toilet?",
    },
    {
      ...messageQuestionProps,
      name: "Severity",
      question:
        "If yes this customer must be advised that a new toilet is required and change job type to 'Install Bathroom Fixture (Bath/Toilet/Sink) [PIBSN]'.",
      depends: 2,
      trigger: "Yes",
    },
    {
      name: "LeakDescription",
      question: "Please describe the leak as drip/trickle/heavy.",
      answers: [
        { value: "drip", text: "Drip" },
        { value: "trickle", text: "Trickle" },
        { value: "heavy", text: "Heavy" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLTIC]]: [
    {
      ...radioQuestionProps,
      name: "TapRepairReplace",
      question: "Are you looking for a repair or replacement?",
      answers: [
        { value: "repair", text: "Repair" },
        { value: "replacement", text: "Replacement" },
      ],
    },
    {
      ...messageQuestionProps,
      name: "TapChangeToRepair",
      question:
        "If this is a repair, change job type to 'Repair of an internal tap [PLTRP]'.",
      depends: 0,
      altJobTypes: [JobTypesWithRequirements[JobTypesWithRequirements.PLTRP]],
      trigger: "Repair",
    },
    {
      ...radioYesNoProps,
      name: "TapAlreadyPurchased",
      question: "Have you already purchased a replacement?",
    },
    {
      ...messageQuestionProps,
      name: "TapChangeToStandardReplacement",
      question:
        "If the customer isn't supplying the replacement tap, change job type to 'Replacement of a standard internal tap [PLTRT]'.",
      depends: 2,
      altJobTypes: [JobTypesWithRequirements[JobTypesWithRequirements.PLTRT]],
      trigger: "No",
    },
    {
      ...radioQuestionProps,
      name: "TapPlacement",
      question: "Is the tap on a kitchen sink, basin or bath?",
      answers: [
        { value: "kitchen sink", text: "Kitchen Sink" },
        { value: "basin", text: "Basin" },
        { value: "bath", text: "Bath" },
      ],
    },
    {
      ...radioQuestionProps,
      name: "TapType",
      question: "Is it one mixer tap or a pair of separate taps?",
      answers: [
        { value: "mixer", text: "Mixer" },
        { value: "pair of taps", text: "Pair of Taps" },
      ],
    },
    {
      ...radioYesNoProps,
      name: "TapAccesibility",
      question: "Is the tap fully accessible underneath?",
    },
    {
      ...radioQuestionProps,
      name: "TapPosition",
      question: "Is it wall-mounted or concealed?",
      answers: [
        { value: "wall-mounted", text: "Wall-Mounted" },
        { value: "concealed", text: "Concealed" },
      ],
    },
    {
      ...radioQuestionProps,
      name: "TapTechnology",
      question:
        "Is it a standard tap, or does it filter, boil, or electronically control the water?",
      answers: [
        { value: "standard", text: "Standard" },
        { value: "boils water", text: "Boils Water" },
        {
          value: "electronically controls water",
          text: "Electronically Controls Water",
        },
      ],
    },
    // {
    //   ...textQuestionProps,
    //   name: "TapLeakages",
    //   question:
    //     "Is any associated pipework, waste or sanitaryware also leaking or damaged?",
    // },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLTNK]]: [
    {
      name: "LeakLocation",
      question: "Where is it leaking?",
      answers: [
        { value: "tank", text: "Tank" },
        { value: "pipework", text: "Pipework To Tank" },
        { value: "valve", text: "Valve On Tank" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoBooleanProps,
      name: "CanIsolateTank",
      question: "Can the tank be isolated?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLTRP]]: [
    {
      ...radioQuestionProps,
      name: "TapRepairReplace",
      question: "Are you looking for a repair or replacement?",
      answers: [
        { value: "repair", text: "Repair" },
        { value: "replacement", text: "Replacement" },
      ],
    },
    {
      ...messageQuestionProps,
      name: "TapChangeToReplacement",
      question:
        "The customer has confirmed this is a replacement, not a repair. Check if the customer is supplying the replcament tap and change the job type to one of the below.",
      depends: 0,
      altJobTypes: [
        JobTypesWithRequirements[JobTypesWithRequirements.PLTRT],
        JobTypesWithRequirements[JobTypesWithRequirements.PLTIC],
      ],
      trigger: "Replacement",
    },
    {
      ...radioQuestionProps,
      name: "TapPlacement",
      question: "Is the tap on a kitchen sink, basin or bath?",
      answers: [
        { value: "kitchen sink", text: "Kitchen Sink" },
        { value: "basin", text: "Basin" },
        { value: "bath", text: "Bath" },
      ],
    },
    {
      ...radioQuestionProps,
      name: "TapType",
      question: "Is it one mixer tap or a pair of separate taps?",
      answers: [
        { value: "mixer", text: "Mixer" },
        { value: "pair of taps", text: "Pair of Taps" },
      ],
    },
    {
      ...radioYesNoProps,
      name: "TapAccesibility",
      question: "Is the tap fully accessible underneath?",
    },
    {
      ...radioQuestionProps,
      name: "TapPosition",
      question: "Is it wall-mounted or concealed?",
      answers: [
        { value: "wall-mounted", text: "Wall-Mounted" },
        { value: "concealed", text: "Concealed" },
      ],
    },
    {
      ...radioQuestionProps,
      name: "TapTechnology",
      question:
        "Is it a standard tap, or does it filter, boil or electronically control the water?",
      answers: [
        { value: "standard", text: "Standard" },
        { value: "boils water", text: "Boils Water" },
        {
          value: "electronically controls water",
          text: "Electronically Controls Water",
        },
      ],
    },
    {
      ...textQuestionProps,
      name: "TapLeakages",
      question:
        "Is any associated pipework, waste or sanitaryware also leaking or damaged?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLTRT]]: [
    {
      ...radioQuestionProps,
      name: "TapRepairReplace",
      question: "Are you looking for a repair or replacement?",
      answers: [
        { value: "repair", text: "Repair" },
        { value: "replacement", text: "Replacement" },
      ],
    },
    {
      ...messageQuestionProps,
      name: "TapChangeToRepair",
      question:
        "If this is a repair, change job type to 'Repair of an internal tap [PLTRP]'.",
      depends: 0,
      altJobTypes: [JobTypesWithRequirements[JobTypesWithRequirements.PLTRP]],
      trigger: "Repair",
    },
    {
      ...radioYesNoProps,
      name: "TapAlreadyPurchased",
      question: "Have you already purchased a replacement?",
    },
    {
      ...messageQuestionProps,
      name: "TapChangeToCustomerReplacement",
      question:
        "If the customer is supplying the replacement tap, change job type to 'Fitting of a customer-supplied internal tap [PLTIC]'.",
      depends: 2,
      altJobTypes: [JobTypesWithRequirements[JobTypesWithRequirements.PLTIC]],
      trigger: "Yes",
    },
    {
      ...radioQuestionProps,
      name: "TapPlacement",
      question: "Is the tap on a kitchen sink, basin or bath?",
      answers: [
        { value: "kitchen sink", text: "Kitchen Sink" },
        { value: "basin", text: "Basin" },
        { value: "bath", text: "Bath" },
      ],
    },
    {
      ...radioQuestionProps,
      name: "TapType",
      question: "Is it one mixer tap or a pair of separate taps?",
      answers: [
        { value: "mixer", text: "Mixer" },
        { value: "pair of taps", text: "Pair of Taps" },
      ],
    },
    {
      ...radioYesNoProps,
      name: "TapAccesibility",
      question: "Is the tap fully accessible underneath?",
    },
    {
      ...radioQuestionProps,
      name: "TapPosition",
      question: "Is it wall-mounted or concealed?",
      answers: [
        { value: "wall-mounted", text: "Wall-Mounted" },
        { value: "concealed", text: "Concealed" },
      ],
    },
    {
      ...radioQuestionProps,
      name: "TapTechnology",
      question:
        "Is it a standard tap, or does it filter, boil or electronically control the water?",
      answers: [
        { value: "standard", text: "Standard" },
        { value: "boils water", text: "Boils Water" },
        {
          value: "electronically controls water",
          text: "Electronically Controls Water",
        },
      ],
    },
    // {
    //   ...textQuestionProps,
    //   name: "TapLeakages",
    //   question:
    //     "Is any associated pipework, waste or sanitaryware also leaking or damaged?",
    // },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PTOTH]]: [
    {
      name: "TapIssue",
      question: "What is wrong with the tap?",
      answers: [
        { value: "dripping", text: "Dripping" },
        { value: "leaking", text: "Leaking" },
        { value: "off", text: "Tap has come off" },
        { value: "nowater", text: "No water coming through" },
        { value: "lowpressure", text: "Low pressure" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "RepairOrReplace",
      question: "Is this a repair or replace?",
      answers: [
        { value: "replace", text: "Replace" },
        { value: "repair", text: "Repair" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.SPRBB]]: [
    {
      name: "TapType",
      question: "What type of tap is it?",
      answers: [
        { value: "mixer", text: "Mixer" },
        { value: "single", text: "Single" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "SingleTap",
      question: "Is this hot or cold tap?",
      answers: [
        { value: "hot", text: "Hot" },
        { value: "cold", text: "Cold" },
      ],
      type: "radio",
      depends: 1,
      trigger: "Single",
    },
    {
      name: "LeakSeverity",
      question: "How severe is the leak?",
      answers: [
        { value: "drip", text: "Drip" },
        { value: "trickle", text: "Trickle" },
        { value: "heavy", text: "Heavy" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "TapLocation",
      question: "Where is the tap located?",
      answers: [
        { value: "kitchensink", text: "Kitchen sink" },
        { value: "bathroombath", text: "Bathroom bath" },
        { value: "bathroombasin", text: "Bathroom basin" },
        { value: "other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.SPIDW]]: [
    {
      name: "ApplianceType",
      question: "What needs to be connected?",
      answers: [
        { value: "washingmachine", text: "Washing machine" },
        { value: "dishwasher", text: "Dishwasher" },
        { value: "americanfridge", text: "American fridge" },
        {
          value: "integratedwashingmachine",
          text: "Integrated washing machine",
        },
        { value: "integrateddishwasher", text: "Integrated dishwasher" },
        { value: "other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...textQuestionProps,
      name: "ApplianceName",
      question: "Appliance Name",
    },
    {
      ...radioYesNoProps,
      name: "ConnectedBefore",
      question: "Was the appliance connected there before?",
    },
    {
      name: "AttachmentsAvailable",
      question: "Does the customer have all attachments?",
      answers: [
        { value: "yes", text: "Yes" },
        { value: "no", text: "No" },
        { value: "n", text: "N" },
        { value: "a", text: "A" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PICYL]]: [
    {
      ...radioYesNoProps,
      name: "FreshInstallation",
      question: "Is this a fresh installation?",
    },
    {
      ...radioYesNoProps,
      name: "SupplyPart",
      question: "Would you like us to supply the part?",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of cylinder?",
    },
    {
      name: "VentedOrUnvented",
      question: "Is it vented or unvented?",
      answers: [
        { value: "Vented", text: "Vented" },
        { value: "Unvented", text: "Unvented" },
        { value: "DontKnow", text: "Don’t know" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PISHW]]: [
    {
      ...radioYesNoProps,
      name: "FreshInstallation",
      question: "Is this a fresh installation?",
    },
    {
      ...radioYesNoProps,
      name: "SupplyPart",
      question: "Would you like us to supply the part?",
    },
    {
      name: "Location",
      question: "Where in the property is it going?",
      answers: [
        { value: "overbath", text: "Over bath" },
        { value: "cubicle", text: "Cubicle" },
        { value: "wetroom", text: "Wetroom" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PITNK]]: [
    {
      ...radioYesNoProps,
      name: "Installation",
      question: "Is this a fresh installation?",
    },
    {
      ...radioYesNoProps,
      name: "SupplyPart",
      question: "Would you like us to supply the part?",
    },
    {
      name: "HotOrCold",
      question: "Is this a hot or cold water tank?",
      answers: [
        { value: "hot", text: "Hot" },
        { value: "cold", text: "Cold" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "GasOrElectric",
      question:
        "If hot, is it mains gas or electric (if it is neither it is TNC)",
      answers: [
        { value: "gas", text: "Gas" },
        { value: "electric", text: "Electric" },
        { value: "notapplicable", text: "Not Applicable" },
      ],
      type: "radio",
      depends: 2,
      trigger: "Hot",
    },
    {
      name: "VentedOrUnvented",
      question: "If hot, is it vented or unvented?",
      answers: [
        { value: "vented", text: "Vented" },
        { value: "unvented", text: "Unvented" },
        { value: "dontknow", text: "Don't know" },
      ],
      type: "radio",
      depends: 2,
      trigger: "Hot",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PIUCY]]: [
    {
      ...radioYesNoBooleanProps,
      name: "FreshInstallation",
      question: "Is this a fresh installation?",
    },
    {
      name: "VentedOrUnvented",
      question: "Is it vented or unvented?",
      answers: [
        { value: "Vented", text: "Vented" },
        { value: "Unvented", text: "Unvented" },
        { value: "DontKnow", text: "Don’t know" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoBooleanProps,
      name: "SupplyParts",
      question: "Would you like us to supply the part?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EEFBI]]: [
    {
      ...radioYesNoProps,
      name: "FreshInstallation",
      question: "Is this a fresh installation?",
    },
    {
      ...radioYesNoProps,
      name: "SupplyPart",
      question: "Would you like us to supply the part?",
    },
    {
      name: "NumBedrooms",
      question: "How many bedrooms in the property?",
      answers: [
        { value: "One", text: "One" },
        { value: "Two", text: "Two" },
        { value: "Three", text: "Three" },
        { value: "Four", text: "Four" },
        { value: "FiveOrMore", text: "Five or more" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.FPTPO]]: [
    {
      ...radioYesNoBooleanProps,
      name: "FreshInstallation",
      question: "Is this a fresh installation?",
    },
    {
      ...radioYesNoBooleanProps,
      name: "SupplyParts",
      question: "Would you like us to supply the part?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.FPTPT]]: [
    {
      ...radioYesNoBooleanProps,
      name: "FreshInstallation",
      question: "Is this a fresh installation?",
    },
    {
      ...radioYesNoBooleanProps,
      name: "SupplyParts",
      question: "Would you like us to supply the part?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLINR]]: [
    {
      ...radioYesNoBooleanProps,
      name: "FreshInstallation",
      question: "Is this a fresh installation?",
    },
    {
      ...radioYesNoBooleanProps,
      name: "SupplyPart",
      question: "Would you like us to supply the part?",
    },
    {
      ...messageQuestionProps,
      name: "RadiatorsLocation",
      question: "Where are the radiators going in the property?",
      depends: 2,
    },
    {
      name: "SingleOrDoubleTrack",
      question: "Are they single or double track radiators?",
      answers: [
        { value: "single", text: "Single" },
        { value: "double", text: "Double" },
        { value: "mixture", text: "Mixture" },
        { value: "unsure", text: "Unsure" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EESOW]]: [
    {
      name: "SocketType",
      question: "What type of socket?",
      answers: [
        { value: "SingleSocket", text: "Single socket" },
        { value: "DoubleSocket", text: "Double socket" },
        { value: "IsolationSwitch", text: "Isolation switch" },
        { value: "PullCordSwitch", text: "Pull cord switch" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "SocketLocation",
      question: "Where in the property are they required?",
      answers: [
        { value: "Bathroom", text: "Bathroom" },
        { value: "Lounge", text: "Lounge" },
        { value: "Bedroom", text: "Bedroom" },
        { value: "Outside", text: "Outside" },
        { value: "Kitchen", text: "Kitchen" },
        { value: "UtilityRoom", text: "Utility room" },
        { value: "Conservatory", text: "Conservatory" },
        { value: "MultipleRooms", text: "Multiple rooms" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "RepairOrReplace",
      question: "Is it to repair or replace?",
      answers: [
        { value: "Repair", text: "Repair" },
        { value: "Replace", text: "Replace" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HBGAS]]: [
    {
      ...radioYesNoProps,
      name: "MainsGasBoiler",
      question: "Is it a mains gas boiler?",
    },
    {
      ...messageQuestionProps,
      name: "ChangeJobType",
      question:
        "If boiler is electric, please change job type to water cylinder. If boiler is LPG please change to correct job type. If boiler is any other fuel, this is not covered.",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoProps,
      name: "BackBoiler",
      question: "Is it a back boiler? (behind the fire)",
    },
    {
      ...textQuestionProps,
      name: "NotWorking",
      question: "What is not working?",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model",
    },
    {
      name: "DownDuration",
      question: "How long has it been down?",
      answers: [
        { value: "today", text: "Today" },
        { value: "1day", text: "1 day" },
        { value: "2days", text: "2 days" },
        { value: "3days", text: "3 days" },
        { value: "4days", text: "4 days" },
        { value: "5ormoredays", text: "5 or more days" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HBSAS]]: [
    {
      ...radioYesNoProps,
      name: "MainsGasBoiler",
      question: "Is it a mains gas boiler?",
    },
    {
      ...messageQuestionProps,
      name: "ChangeJobType",
      question:
        "If boiler is electric, please change job type to water cylinder. If boiler is LPG please change to correct job type. If boiler is any other fuel, this is not covered.",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoProps,
      name: "WorkingOrder",
      question: "Is it in working order?",
    },
    {
      ...messageQuestionProps,
      name: "RepairBeforeService",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair.",
      depends: 2,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HLBDW]]: [
    {
      ...radioYesNoProps,
      name: "LpgGasBoiler",
      question: "Is it a LPG gas boiler?",
    },
    {
      ...messageQuestionProps,
      name: "ChangeJobType",
      question:
        "If boiler is electric, please change job type to water cylinder. If boiler is mains please change to correct job type. If boiler is any other fuel, this is not covered.",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoProps,
      name: "BackBoiler",
      question: "Is it a back boiler? (behind the fire)",
    },
    {
      ...textQuestionProps,
      name: "NotWorking",
      question: "What is not working?",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model",
    },
    {
      name: "DownDuration",
      question: "How long has it been down?",
      answers: [
        { value: "today", text: "Today" },
        { value: "1day", text: "1 day" },
        { value: "2days", text: "2 days" },
        { value: "3days", text: "3 days" },
        { value: "4days", text: "4 days" },
        { value: "5ormoredays", text: "5 or more days" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HBSMK]]: [
    {
      ...radioYesNoProps,
      name: "MainsGasBoiler",
      question: "Is it a mains gas boiler?",
    },
    {
      ...messageQuestionProps,
      name: "ChangeJobType",
      question:
        "If boiler is electric, please change job type to water cylinder. If boiler is LPG please change to correct job type. If boiler is any other fuel, this is not covered.",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoProps,
      name: "WorkingOrder",
      question: "Is it in working order?",
    },
    {
      ...messageQuestionProps,
      name: "RepairBeforeService",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair.",
      depends: 2,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HCERT]]: [
    {
      ...radioYesNoProps,
      name: "MainsGasBoiler",
      question: "Is it a mains gas boiler?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question: "If boiler is not mains gas, this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoProps,
      name: "WorkingOrder",
      question: "Is it in working order?",
    },
    {
      ...messageQuestionProps,
      name: "RepairBeforeService",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair.",
      depends: 2,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HBSCP]]: [
    {
      ...radioYesNoBooleanProps,
      name: "MainsGasBoiler",
      question: "Is it a mains gas boiler?",
    },
    {
      name: "GasAppliances",
      question: "How many gas appliances?",
      answers: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5ormore", text: "5 or more" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "WorkingOrder",
      question: "Is it in working order?",
    },
    {
      ...messageQuestionProps,
      name: "RepairBeforeService",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair.",
      depends: 2,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of boiler and appliances, if known",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HCFCB]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it a mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question: "If boiler is not mains gas, this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoProps,
      name: "WorkingOrder",
      question: "Is it in working order?",
    },
    {
      ...messageQuestionProps,
      name: "RepairBeforeService",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair.",
      depends: 2,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of boiler and appliances if known",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HCFCO]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it a mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question: "If boiler is not mains gas, this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoProps,
      name: "WorkingOrder",
      question: "Is it in working order?",
    },
    {
      ...messageQuestionProps,
      name: "RepairAndUpsell",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair",
      depends: 2,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of appliances if known",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HCPBC]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it a mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question: "If boiler is not mains gas, this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoProps,
      name: "WorkingOrder",
      question: "Is it in working order?",
    },
    {
      ...messageQuestionProps,
      name: "RepairAndUpsell",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair",
      depends: 2,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of boiler and appliances if known",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HCPBF]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it a mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question: "If boiler is not mains gas, this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoProps,
      name: "WorkingOrder",
      question: "Is it in working order?",
    },
    {
      ...messageQuestionProps,
      name: "RepairAndUpsell",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair",
      depends: 2,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of boiler and appliances if known",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HCPCO]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it a mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question: "If appliances are not mains gas, this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoProps,
      name: "WorkingOrder",
      question: "Is it in working order?",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of appliances if known",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HCPFO]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it a mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question: "If appliances are not mains gas, this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoProps,
      name: "WorkingOrder",
      question: "Is it in working order?",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of appliances if known",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HIGAS]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it a mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question: "If boiler is not mains gas, this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoBooleanProps,
      name: "NewInstallation",
      question: "Is this a new installation?",
    },
    {
      ...radioYesNoBooleanProps,
      name: "SupplyBoiler",
      question: "Would you like us to supply the boiler?",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of current boiler",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HIWTR]]: [
    {
      name: "GasOrElectric",
      question: "Is it gas or electric?",
      answers: [
        { value: "gas", text: "Gas" },
        { value: "electric", text: "Electric" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "If cylinder is gas, is it mains gas?",
      depends: 0,
      trigger: "Gas",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question:
        "If cylinder is not mains gas, this is Plumbing, install water tank",
      depends: 1,
      trigger: "No",
    },
    {
      ...radioYesNoBooleanProps,
      name: "NewInstallation",
      question: "Is this a new installation?",
    },
    {
      ...radioYesNoBooleanProps,
      name: "SupplyCylinder",
      question: "Would you like us to supply the cylinder?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PWFLS]]: [
    {
      name: "MainsGas",
      question: "Is it mains gas heating system?",
      answers: [
        { value: "yes", text: "Yes" },
        {
          value: "no",
          text: "No",
        },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question: "If heating system is not mains gas, this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      name: "NumRadiators",
      question: "How many radiators are in the property?",
      answers: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "morethan10", text: "More than 10" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...textQuestionProps,
      name: "PowerflushReason",
      question: "How do you know a powerflush is required?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.LRGAZ]]: [
    {
      ...radioYesNoBooleanProps,
      name: "Owner",
      question: "Is this your property?",
    },
    {
      name: "InternalOrExternal",
      question: "Is it an internal or external door?",
      answers: [
        { value: "internal", text: "Internal" },
        { value: "external", text: "External" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.LRGCL]]: [
    {
      ...radioYesNoBooleanProps,
      name: "Owner",
      question: "Is this your property?",
    },
    {
      name: "InternalOrExternal",
      question: "Is it an internal or external door?",
      answers: [
        { value: "internal", text: "Internal" },
        { value: "external", text: "External" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "LockHeight",
      question: "Is the lock waist height or shoulder height?",
      answers: [
        { value: "waist", text: "Waist" },
        { value: "shoulder", text: "Shoulder" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.LRGML]]: [
    {
      ...radioYesNoBooleanProps,
      name: "Owner",
      question: "Is this your property?",
    },
    {
      ...textQuestionProps,
      name: "What",
      question: "What are we gaining access to?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLSTP]]: [
    {
      ...textQuestionProps,
      name: "PipeworkFor",
      question: "What is the pipework for?",
    },
    {
      name: "PipeworkLocation",
      question: "Where in the property is it required?",
      answers: [
        { value: "Kitchen", text: "Kitchen" },
        { value: "Bedroom", text: "Bedroom" },
        { value: "Bathroom", text: "Bathroom" },
        { value: "Toilet", text: "Toilet" },
        { value: "UtilityRoom", text: "Utility room" },
        { value: "Various", text: "Various" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "PipeMaterial",
      question: "What is the pipe made of?",
      answers: [
        { value: "Copper", text: "Copper" },
        {
          value: "Lead",
          text: "Lead (if lead pipe we can only replace not repair)",
        },
        { value: "Plastic", text: "Plastic" },
        { value: "Steel", text: "Steel" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.PLWKE]]: [
    {
      ...textQuestionProps,
      name: "PipePurpose",
      question: "What is the pipework for?",
    },
    {
      name: "PipeLocation",
      question: "Where in the property are they required?",
      answers: [
        { value: "kitchen", text: "Kitchen" },
        { value: "bedroom", text: "Bedroom" },
        { value: "bathroom", text: "Bathroom" },
        { value: "toilet", text: "Toilet" },
        { value: "utility", text: "Utility room" },
        { value: "various", text: "Various" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "PipeMaterial",
      question: "What is the pipe made of?",
      answers: [
        { value: "copper", text: "Copper" },
        {
          value: "lead",
          text: "Lead (if lead pipe we can only replace not repair)",
        },
        { value: "plastic", text: "Plastic" },
        { value: "steel", text: "Steel" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EECLR]]: [
    {
      name: "LightType",
      question: "What type of lights?",
      answers: [
        { value: "Pendant", text: "Pendant" },
        { value: "SpotLight", text: "Spot light" },
        { value: "Led", text: "LED" },
        { value: "FluorescentTubing", text: "Fluorescent tubing" },
        { value: "Security", text: "Security" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "Location",
      question: "Where in the property are they required?",
      answers: [
        { value: "Bathroom", text: "Bathroom" },
        { value: "Lounge", text: "Lounge" },
        { value: "Bedroom", text: "Bedroom" },
        { value: "Outside", text: "Outside" },
        { value: "Kitchen", text: "Kitchen" },
        { value: "UtilityRoom", text: "Utility room" },
        { value: "Conservatory", text: "Conservatory" },
        { value: "MultipleRooms", text: "Multiple rooms" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...textQuestionProps,
      name: "TotalLights",
      question: "How many lights in total?",
    },
    {
      name: "RepairOrReplace",
      question: "Is this job repair or replace?",
      answers: [
        { value: "Repair", text: "Repair" },
        { value: "Replace", text: "Replace" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EERWI]]: [
    {
      name: "PropertyType",
      question: "What type of property?",
      answers: [
        { value: "House", text: "House" },
        { value: "Bungalow", text: "Bungalow" },
        { value: "Property", text: "Property" },
        { value: "Apartment", text: "Apartment" },
        { value: "Business", text: "Business" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "NumBedrooms",
      question: "How many bedrooms in the property?",
      answers: [
        { value: "One", text: "One" },
        { value: "Two", text: "Two" },
        { value: "Three", text: "Three" },
        { value: "Four", text: "Four" },
        { value: "FiveOrMore", text: "Five or more" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EELSR]]: [
    {
      name: "Location",
      question: "Where in the property are they required?",
      answers: [
        { value: "Bathroom", text: "Bathroom" },
        { value: "Lounge", text: "Lounge" },
        { value: "Bedroom", text: "Bedroom" },
        { value: "Outside", text: "Outside" },
        { value: "Kitchen", text: "Kitchen" },
        { value: "UtilityRoom", text: "Utility room" },
        { value: "Conservatory", text: "Conservatory" },
        { value: "MultipleRooms", text: "Multiple rooms" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "SwitchType",
      question: "What type of switch?",
      answers: [
        { value: "SingleSocket", text: "Single socket" },
        { value: "DoubleSocket", text: "Double socket" },
        { value: "IsolationSwitch", text: "Isolation switch" },
        { value: "PullCordSwitch", text: "Pull cord switch" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "RepairOrReplace",
      question: "Is this job repair or replace?",
      answers: [
        { value: "Repair", text: "Repair" },
        { value: "Replace", text: "Replace" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...textQuestionProps,
      name: "NumSwitches",
      question: "How many switches in total?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HIHOR]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it a mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question:
        "If appliance is not mains gas, this is electrics or TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    {
      name: "DomesticOrCommercial",
      question: "Is this domestic or commercial?",
      answers: [
        { value: "domestic", text: "Domestic" },
        { value: "commercial", text: "Commercial" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCoveredIfCommercial",
      question:
        "If this project is commercial, please check with the team leader if we have a commercial gas engineer available in the area. If not available, TRADE is not covered",
      depends: 2,
      trigger: "Commercial",
    },
    {
      name: "GasRunFor",
      question:
        "What is the purpose of the gas run? (e.g., cooker, fire, other)",
      answers: [
        { value: "cooker", text: "Cooker" },
        { value: "fire", text: "Fire" },
        { value: "other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "LengthOfPiping",
      question: "Do you know the required length of piping?",
      answers: [
        { value: "no", text: "No" },
        { value: "yes", text: "Yes" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...textQuestionProps,
      name: "LengthOfPipingInMeters",
      question: "What is the total length of piping required in meters?",
      depends: 5,
      trigger: "Yes",
    },
    {
      ...radioYesNoProps,
      name: "ConnectAppliance",
      question:
        "Will the appliance be connected during the gas run installation?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.LRGAI]]: [
    {
      ...radioYesNoProps,
      name: "IsThisYourProperty",
      question: "Is this your property?",
    },
    {
      ...messageQuestionProps,
      name: "CheckWithTL",
      question:
        "Please check with the team leader if we need authorisation to do the job",
      depends: 0,
      trigger: "No",
    },
    {
      name: "InternalOrExternalDoor",
      question: "Is it an internal or external door?",
      answers: [
        { value: "internal", text: "Internal" },
        { value: "external", text: "External" },
        { value: "other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "TypeOfDoor",
      question: "What type of door is it?",
      answers: [
        { value: "wood", text: "Wood" },
        { value: "upvc", text: "UPVC" },
        { value: "metal", text: "Metal" },
        { value: "composite", text: "Composite" },
        { value: "other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "LockHeight",
      question: "Is the lock waist height or shoulder height?",
      answers: [
        { value: "waist", text: "Waist" },
        { value: "shoulder", text: "Shoulder" },
        { value: "other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "OtherLocks",
      question: "Are there any other locks on the door?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.LREPL]]: [
    {
      ...radioYesNoProps,
      name: "IsThisYourProperty",
      question: "Is this your property?",
    },
    {
      ...messageQuestionProps,
      name: "CheckWithTL",
      question:
        "Please check with the team leader if we need authorisation to do the job",
      depends: 0,
      trigger: "No",
    },
    {
      name: "InternalOrExternalDoor",
      question: "Is it an internal or external door?",
      answers: [
        { value: "internal", text: "Internal" },
        { value: "external", text: "External" },
        { value: "other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "TypeOfDoor",
      question: "What type of door is it?",
      answers: [
        { value: "wood", text: "Wood" },
        { value: "upvc", text: "UPVC" },
        { value: "metal", text: "Metal" },
        { value: "composite", text: "Composite" },
        { value: "other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "LockHeight",
      question: "Is the lock waist height or shoulder height?",
      answers: [
        { value: "waist", text: "Waist" },
        { value: "shoulder", text: "Shoulder" },
        { value: "other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "OtherLocks",
      question: "Are there any other locks on the door?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.LREPA]]: [
    {
      ...radioYesNoProps,
      name: "IsThisYourProperty",
      question: "Is this your property?",
    },
    {
      ...messageQuestionProps,
      name: "CheckWithTL",
      question:
        "Please check with the team leader if we need authorisation to do the job",
      depends: 0,
      trigger: "No",
    },
    {
      name: "InternalOrExternalDoor",
      question: "Is it an internal or external door?",
      answers: [
        { value: "internal", text: "Internal" },
        { value: "external", text: "External" },
        { value: "other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "TypeOfDoor",
      question: "What type of door is it?",
      answers: [
        { value: "wood", text: "Wood" },
        { value: "upvc", text: "UPVC" },
        { value: "metal", text: "Metal" },
        { value: "composite", text: "Composite" },
        { value: "other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      name: "LockHeight",
      question: "Is the lock waist height or shoulder height?",
      answers: [
        { value: "waist", text: "Waist" },
        { value: "shoulder", text: "Shoulder" },
        { value: "other", text: "Other" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "OtherLocks",
      question: "Are there any other locks on the door?",
    },
  ],
  // HLGAS	H	R	LPG Boiler Breakdown	What is not working?		Make and model		How long has it been down?	Today/1 day/2 days/3 days/4 days/5 or more days
  [JobTypesWithRequirements[JobTypesWithRequirements.HLGAS]]: [
    {
      ...radioYesNoProps,
      name: "IsItWorking",
      question: "Is it working?",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of boiler",
    },
    {
      name: "HowLongDown",
      question: "How long has it been down?",
      answers: [
        { value: "today", text: "Today" },
        { value: "oneday", text: "1 day" },
        { value: "twodays", text: "2 days" },
        { value: "threedays", text: "3 days" },
        { value: "fourdays", text: "4 days" },
        { value: "fivedays", text: "5 or more days" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  // HLSAS	H	S	LPG Back Boiler Service	Is it in working order?	Yes/No	If no customer must be made aware boiler must be repaired before it can be serviced then change job type to repair & raise boiler upsell for after repair
  [JobTypesWithRequirements[JobTypesWithRequirements.HLSAS]]: [
    {
      ...radioYesNoProps,
      name: "IsItWorking",
      question: "Is it working?",
    },
    {
      ...messageQuestionProps,
      name: "RepairAndUpsell",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair",
      depends: 0,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of boiler",
    },
  ],
  //   HLSCP	H	C	LPG Cp12 With Boiler Service	Is it in working order?	Yes/No	If no customer must be made aware boiler must be repaired before it can be serviced then change job type to repair & raise boiler upsell for after repair		Make and model of boiler and appliances if known
  [JobTypesWithRequirements[JobTypesWithRequirements.HLSCP]]: [
    {
      ...radioYesNoProps,
      name: "IsItWorking",
      question: "Is it working?",
    },
    {
      ...messageQuestionProps,
      name: "RepairAndUpsell",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair",
      depends: 0,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of boiler",
    },
  ],
  // HLSMK	H	S	LPG Boiler Service (Marketing Offer)	Is it in working order?	Yes/No	If no customer must be made aware boiler must be repaired before it can be serviced then change job type to repair & raise boiler upsell for after repair		Make and model
  [JobTypesWithRequirements[JobTypesWithRequirements.HLSMK]]: [
    {
      ...radioYesNoProps,
      name: "IsItWorking",
      question: "Is it working?",
    },
    {
      ...messageQuestionProps,
      name: "RepairAndUpsell",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair",
      depends: 0,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of boiler",
    },
    {
      ...textQuestionProps,
      name: "ApplianceMakeAndModel",
      question: "Make and model of appliances if known",
    },
  ],
  // HLERT	H	C	LPG Cp12 (Boiler Only)	Is it in working order?	Yes/No	If no customer must be made aware boiler must be repaired before it can be serviced then change job type to repair & raise boiler upsell for after repair		Make and model
  [JobTypesWithRequirements[JobTypesWithRequirements.HLERT]]: [
    {
      ...radioYesNoProps,
      name: "IsItWorking",
      question: "Is it working?",
    },
    {
      ...messageQuestionProps,
      name: "RepairAndUpsell",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair",
      depends: 0,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of boiler",
    },
  ],
  // HLFCB	H	C	LPG Cp12 (Fire Cooker And Boiler)	Is it in working order?	Yes/No	If no customer must be made aware boiler must be repaired before it can be serviced then change job type to repair & raise boiler upsell for after repair		Make and model of boiler and appliances if known
  [JobTypesWithRequirements[JobTypesWithRequirements.HLFCB]]: [
    {
      ...radioYesNoProps,
      name: "IsItWorking",
      question: "Is it working?",
    },
    {
      ...messageQuestionProps,
      name: "RepairAndUpsell",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair",
      depends: 0,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of boiler",
    },
    {
      ...textQuestionProps,
      name: "ApplianceMakeAndModel",
      question: "Make and model of appliances if known",
    },
  ],
  // HLFCO	H	C	LPG Cp12 (Fire And Cooker Only)	Is it in working order?	Yes/No	Make and model of  appliances if known
  [JobTypesWithRequirements[JobTypesWithRequirements.HLFCO]]: [
    {
      ...radioYesNoProps,
      name: "IsItWorking",
      question: "Is it working?",
    },
    {
      ...textQuestionProps,
      name: "ApplianceMakeAndModel",
      question: "Make and model of appliances if known",
    },
  ],
  // HLPBC	H	C	LPG Cp12 (Boiler And Cooker Only)	Is it in working order?	Yes/No	If no customer must be made aware boiler must be repaired before it can be serviced then change job type to repair & raise boiler upsell for after repair		Make and model of boiler and appliances if known
  [JobTypesWithRequirements[JobTypesWithRequirements.HLPBC]]: [
    {
      ...radioYesNoProps,
      name: "IsItWorking",
      question: "Is it working?",
    },
    {
      ...messageQuestionProps,
      name: "RepairAndUpsell",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair",
      depends: 0,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of boiler",
    },
    {
      ...textQuestionProps,
      name: "ApplianceMakeAndModel",
      question: "Make and model of appliances if known",
    },
  ],
  // HLPBF	H	C	LPG Cp12 (Boiler And Fire Only)	Is it in working order?	Yes/No	If no customer must be made aware boiler must be repaired before it can be serviced then change job type to repair & raise boiler upsell for after repair		Make and model of boiler and appliances if known
  [JobTypesWithRequirements[JobTypesWithRequirements.HLPBF]]: [
    {
      ...radioYesNoProps,
      name: "IsItWorking",
      question: "Is it working?",
    },
    {
      ...messageQuestionProps,
      name: "RepairAndUpsell",
      question:
        "If no, customer must be made aware boiler must be repaired before it can be serviced, then change job type to repair & raise boiler upsell for after repair",
      depends: 0,
      trigger: "No",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of boiler",
    },
    {
      ...textQuestionProps,
      name: "ApplianceMakeAndModel",
      question: "Make and model of appliances if known",
    },
  ],
  // HLPCO	H	C	LPG Cp12 (Cooker Only)	Is it in working order?	Yes/No	Make and model of  appliances if known
  [JobTypesWithRequirements[JobTypesWithRequirements.HLPCO]]: [
    {
      ...radioYesNoProps,
      name: "IsItWorking",
      question: "Is it working?",
    },
    {
      ...textQuestionProps,
      name: "ApplianceMakeAndModel",
      question: "Make and model of appliances if known",
    },
  ],
  // HLPFO	H	C	LPG Cp12 (Fire Only)	Is it in working order?	Yes/No	Make and model of  appliances if known
  [JobTypesWithRequirements[JobTypesWithRequirements.HLPFO]]: [
    {
      ...radioYesNoProps,
      name: "IsItWorking",
      question: "Is it working?",
    },
    {
      ...textQuestionProps,
      name: "ApplianceMakeAndModel",
      question: "Make and model of appliances if known",
    },
  ],
  // HLGAS	H	I	Install LPG Boiler	Is this a new installation?	Yes/No	Would you like us to supply the boiler?	Yes/No	Make and model of current boiler
  [JobTypesWithRequirements[JobTypesWithRequirements.HLGAS]]: [
    {
      ...radioYesNoProps,
      name: "NewInstallation",
      question: "Is this a new installation?",
    },
    {
      ...radioYesNoProps,
      name: "SupplyBoiler",
      question: "Would you like us to supply the boiler?",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model of current boiler",
    },
  ],
  // HLHOB	H	I	Install LPG Cooker	Do you have the cooker?	Yes/No	Is the cooker second hand?	Yes/No	Do you have cooker chain and hose?	Chain/Hose/Both/None	Is the cooker going in the same place?	Yes/No
  [JobTypesWithRequirements[JobTypesWithRequirements.HLHOB]]: [
    {
      ...radioYesNoProps,
      name: "HaveCooker",
      question: "Do you have the cooker?",
    },
    {
      ...radioYesNoProps,
      name: "SecondHand",
      question: "Is the cooker second hand?",
    },
    {
      name: "HaveChainAndHose",
      question: "Do you have cooker chain and hose?",
      answers: [
        { value: "Chain", text: "Chain" },
        { value: "Hose", text: "Hose" },
        { value: "Both", text: "Both" },
        { value: "None", text: "None" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "SamePlace",
      question: "Is the cooker going in the same place?",
    },
  ],
  // HLSMT	H	I	Repair Or Replace A LPG Boiler Thermostat	Is the thermostat on the boiler or away from the boiler?	On Boiler/Off Boiler
  [JobTypesWithRequirements[JobTypesWithRequirements.HLSMT]]: [
    {
      name: "ThermostatLocation",
      question: "Is the thermostat on the boiler or away from the boiler?",
      answers: [
        { value: "OnBoiler", text: "On Boiler" },
        { value: "OffBoiler", text: "Off Boiler" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  // HLWTR	H	I	Install Water Heater	If cylinder is not mains gas this is Plumbing , install water tank		Is this a new installation?	Yes/No	Would you like us to supply the cylinder?	Yes/No
  [JobTypesWithRequirements[JobTypesWithRequirements.HLWTR]]: [
    {
      ...radioYesNoProps,
      name: "NewInstallation",
      question: "Is this a new installation?",
    },
    {
      ...radioYesNoProps,
      name: "SupplyCylinder",
      question: "Would you like us to supply the cylinder?",
    },
  ],
  // HLLEK	H	R	LPG Leak	Was gas capped off by CADENT?	Yes/No	Do you know where the leak is?	Yes/No	Is the leak exposed or hidden?	Exposed/Hidden
  [JobTypesWithRequirements[JobTypesWithRequirements.HLLEK]]: [
    {
      ...radioYesNoBooleanProps,
      name: "KnowWhereLeakIs",
      question: "Do you know where the leak is?",
    },
    {
      name: "LeakExposedOrHidden",
      question: "Is the leak exposed or hidden?",
      answers: [
        { value: "Exposed", text: "Exposed" },
        { value: "Hidden", text: "Hidden" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  // HLFIR	H	S	LPG Fire Service	Is the fire working?	Yes/No	How old is the Fire?	1 Year/2 Years/3 Years/4 Years/5 Years/6 Years/7 Years/8 Years/9 Years/10 Years Or More	Do you have manual?	Yes/No	Make and Model
  [JobTypesWithRequirements[JobTypesWithRequirements.HLFIR]]: [
    {
      ...radioYesNoBooleanProps,
      name: "IsItWorking",
      question: "Is the fire working?",
    },
    {
      ...radioAgeProps,
      name: "HowOld",
      question: "How old is the Fire?",
    },
    {
      ...radioYesNoBooleanProps,
      name: "HaveManual",
      question: "Do you have manual?",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and Model",
    },
  ],
  // HLSRV	H	S	LPG Boiler Service	Is the boiler working?	Yes/No	If boiler is not working this must be booked as gas boiler breakdown and inform the cust must be repaired before servicing		How old is the Boiler?	1 Year/2 Years/3 Years/4 Years/5 Years/6 Years/7 Years/8 Years/9 Years/10 Years Or More	Make and Model
  [JobTypesWithRequirements[JobTypesWithRequirements.HLSRV]]: [
    {
      ...radioYesNoBooleanProps,
      name: "IsItWorking",
      question: "Is the boiler working?",
    },
    {
      ...radioAgeProps,
      name: "HowOld",
      question: "How old is the Boiler?",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and Model",
    },
  ],
  // HLTAT	H	R	Repair an LPG Fire	What is wrong with the fire?		How old is the Fire?	1 Year/2 Years/3 Years/4 Years/5 Years/6 Years/7 Years/8 Years/9 Years/10 Years Or More	Do you have manual?	Yes/No	Make and Model
  [JobTypesWithRequirements[JobTypesWithRequirements.HLTAT]]: [
    {
      ...textQuestionProps,
      name: "WhatIsWrong",
      question: "What is wrong with the fire?",
    },
    {
      ...radioAgeProps,
      name: "HowOld",
      question: "How old is the Fire?",
    },
    {
      ...radioYesNoBooleanProps,
      name: "HaveManual",
      question: "Do you have manual?",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and Model",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HSWBR]]: [
    {
      ...radioYesNoProps,
      name: "MainsGas",
      question: "Is it mains gas?",
    },
    {
      ...messageQuestionProps,
      name: "TradeNotCovered",
      question:
        "If this is not mains gas, but LPG switch to correct job type, otherwise this is TRADE NOT COVERED",
      depends: 0,
      trigger: "No",
    },
    // boiler breakdown job type selected - required options add questions - is it LPG boiler?
    // TODO: add this question to the boiler breakdown job type as required per ticket #14242
    // {
    //   name: "IsLPGBoiler",
    // }
    {
      ...radioYesNoProps,
      name: "BoilerWorking",
      question: "Is the boiler working?",
    },
    {
      ...messageQuestionProps,
      name: "BookGasBoilerBreakdown",
      question:
        "If boiler is not working, this must be booked as a gas boiler breakdown and inform the customer it must be repaired before servicing",
      depends: 2,
      trigger: "No",
    },
    {
      ...radioAgeProps,
      name: "BoilerAge",
      question: "How old is the Boiler?",
    },
    {
      ...textQuestionProps,
      name: "MakeModel",
      question: "Make and Model",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EEVIN]]: [
    {
      ...radioYesNoProps,
      name: "AlreadyBoughtEV",
      question: "Have you already bought an electric vehicle?",
    },
    {
      ...radioYesNoProps,
      name: "PlanningToBuyEV",
      question: "Planning to buy an electric vehicle soon?",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioYesNoProps,
      name: "Driveway",
      question: "Got a driveway for the vehicle?",
      depends: 0,
      trigger: "Yes",
    },
    {
      ...radioYesNoProps,
      name: "ChargerFitted",
      question:
        "Can a charger be fitted outside within 5 to 7 metres of the parking spot?",
      depends: 0,
      trigger: "Yes",
    },
    {
      ...textQuestionProps,
      name: "Location",
      question: "Can you describe the desired location for the charger?",
      depends: 0,
      trigger: "Yes",
    },
    {
      ...radioYesNoProps,
      name: "ConsumerUnit",
      question: "Know where your consumer unit is?",
    },
    {
      ...radioYesNoProps,
      name: "MeterLocation",
      question: "Know the location of your meter?",
    },
    {
      ...radioYesNoProps,
      name: "MeterAtSameLocation",
      question: "Is the meter at the same location as the consumer unit?",
    },
    {
      ...textQuestionProps,
      name: "DistanceFromMeter",
      question: "How far will the charger be from the consumer unit and meter?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.EEVRE]]: [
    {
      ...textQuestionProps,
      name: "IssueDescription",
      question: "Can you describe the issue with the charger?",
    },
    {
      ...radioYesNoProps,
      name: "DamagedPhysically",
      question: "Has the charger been damaged physically?",
    },
    {
      name: "ConnectionOrPowerSupply",
      question: "Is the problem related to the connection or power supply?",
      answers: [
        { value: "connection", text: "Connection" },
        { value: "powerSupply", text: "Power Supply" },
      ],
      type: "radio",
      depends: null,
    },
    {
      ...radioYesNoProps,
      name: "ErrorCodes",
      question: "Do you have any error codes displayed?",
    },
    {
      ...textQuestionProps,
      name: "ErrorCodesProvided",
      question: "If yes: Can you provide the error codes?",
      depends: 3,
      trigger: "Yes",
    },
    {
      ...radioYesNoProps,
      name: "AccessForRepair",
      question: "Can you easily access the charger for repair?",
    },
    {
      ...radioYesNoProps,
      name: "ConsumerUnitLinked",
      question: "Know where your consumer unit is linked to the charger?",
    },
    {
      ...radioYesNoProps,
      name: "MeterLocation",
      question: "Know the location of your meter connected to the charger?",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HBAHP]]: [
    {
      ...textQuestionProps,
      name: "NotWorking",
      question: "What is not working?",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model",
    },
    {
      name: "DownDuration",
      question: "How long has it been down?",
      answers: [
        { value: "today", text: "Today" },
        { value: "1day", text: "1 day" },
        { value: "2days", text: "2 days" },
        { value: "3days", text: "3 days" },
        { value: "4days", text: "4 days" },
        { value: "5ormoredays", text: "5 or more days" },
      ],
      type: "radio",
      depends: null,
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HIAHP]]: [
    {
      ...radioYesNoBooleanProps,
      name: "NewInstallation",
      question: "Is this a new installation?",
    },
    {
      ...radioYesNoBooleanProps,
      name: "SupplyAirSourceHeatPump",
      question: "Would you like us to supply the air source heat pump?",
    },
    {
      ...textQuestionProps,
      name: "MakeAndModel",
      question: "Make and model",
    },
  ],
  [JobTypesWithRequirements[JobTypesWithRequirements.HSAHP]]: [
    {
      ...radioYesNoProps,
      name: "AirSourceHeatPumpWorking",
      question: "Is the air source heat pump working?",
    },
    {
      ...messageQuestionProps,
      name: "BookGasAirSourceHeatPumpBreakdown",
      question:
        "If heat pump is not working, this must be booked as an air source heat pump breakdown and inform the customer it must be repaired before servicing",
      depends: 0,
      trigger: "No",
    },
    {
      ...radioAgeProps,
      name: "AirSourceHeatPumpAge",
      question: "How old is the heat pump?",
    },
    {
      ...textQuestionProps,
      name: "MakeModel",
      question: "Make and Model",
    },
  ],
};
